import * as Blockly from 'blockly/core';
import { defineMutableBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

const COLOR = '#5a9b00';

const TYPE_COLORS: Record<string, string> = {
    float: '#FF1BAC',
    String: '#FF4081',
    bool: '#da00bd',
};

function buildInputs(block: Blockly.Block): void {
    while (block.inputList.length > 0) {
        block.removeInput(block.inputList[0].name ?? '', true);
    }

    const fnName: string = (block as any)._fnName ?? '';
    const params: { id: string; type: 'float' | 'String' | 'bool' }[] = (block as any)._params ?? [];

    const header = block.appendDummyInput('HEADER');
    header.appendField(new (Blockly.FieldImage as any)('/images/block/func.svg', 65, 65, 'icon'));
    header.appendField(new FieldStyledLabel('関数 ', { fontSize: 12, fontWeight: 'bold' }));
    header.appendField(new FieldStyledLabel(fnName, { fontSize: 12, fontWeight: 'bold' }), 'FN_NAME');
    header.appendField(' ');

    params.forEach((p, i) => {
        header.appendField(
            new FieldVariableLabel(`引数${i + 1}`, {
                fontWeight: 'normal',
                varType: p.type,
                isPrivate: true,
                showSymbol: true,
                colorOverride: TYPE_COLORS[p.type],
                onSet: (name, field) => {
                    const block = field.getSourceBlock();
                    if (!block) return true;
                    const ps: { id: string }[] = (block as any)._params ?? [];
                    for (const other of ps) {
                        const otherField = block.getField(`PARAM_${other.id}`) as any;
                        if (otherField && otherField !== field && otherField.getValue() === name) {
                            const idx = ps.indexOf(other);
                            otherField.setVarName(`引数${idx + 1}`);
                        }
                    }
                    return true;
                },
            }),
            `PARAM_${p.id}`,
        );
    });

    block.appendStatementInput('DO');
}

defineMutableBlock({
    type: 'func',
    colour: COLOR,
    tooltip: '関数を定義します',
    deletable: true,
    movable: true,

    init(this: Blockly.Block) {
        this.setColour(COLOR);
        this.setTooltip('関数を定義します');
        this.setMovable(true);
        this.setDeletable(true);
        (this as any)._fnId = '';
        (this as any)._fnName = '';
        (this as any)._params = [];
        buildInputs(this);
    },

    mutationToDom(this: Blockly.Block): Element {
        const container = Blockly.utils.xml.createElement('mutation');
        container.setAttribute('fn_id', (this as any)._fnId ?? '');
        container.setAttribute('fn_name', (this as any)._fnName ?? '');
        container.setAttribute('params', JSON.stringify((this as any)._params ?? []));
        return container;
    },

    domToMutation(this: Blockly.Block, xml: Element): void {
        (this as any)._fnId = xml.getAttribute('fn_id') ?? '';
        (this as any)._fnName = xml.getAttribute('fn_name') ?? '';
        try {
            (this as any)._params = JSON.parse(xml.getAttribute('params') ?? '[]');
        } catch {
            (this as any)._params = [];
        }
        buildInputs(this);
    },
});
